export const pickupDeclarationsRoute: string = "pickup-declarations";
